module.exports = __webpack_public_path__ + "img/kanban.42503e8e.png";